import { twMerge } from 'tailwind-merge';

import { ButtonVariant } from '@homeflow/v4-lib/state';

const BASE_CLASSES =
  'button-variant flex items-center justify-center font-bold gap-2 text-base w-auto rounded-full';
const TRANSITION_CLASSES = 'transition-all duration-200 ease-in-out';

const variantClassNames: { [key in ButtonVariant]?: string } = {
  [ButtonVariant.A]: twMerge(
    BASE_CLASSES,
    'button-variant-a bg-button-primary hover:bg-accent text-button-text hover:text-primary-text',
    TRANSITION_CLASSES
  ),
  [ButtonVariant.B]: twMerge(BASE_CLASSES, 'button-variant-b bg-accent text-black'),
  [ButtonVariant.C]: twMerge(BASE_CLASSES, 'button-variant-c bg-button-tint text-black'),
  [ButtonVariant.D]: twMerge(BASE_CLASSES, 'button-variant-d bg-accent-tint text-black'),
  [ButtonVariant.E]: twMerge(BASE_CLASSES, 'button-variant-e bg-custom-1 text-button-text'),
  [ButtonVariant.F]: twMerge(BASE_CLASSES, 'button-variant-f bg-accent text-black hover:bg-white'),
};

export default variantClassNames;
